import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=90699bfa"
import script from "./UserSearch.vue?vue&type=script&lang=ts"
export * from "./UserSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90699bfa')) {
      api.createRecord('90699bfa', component.options)
    } else {
      api.reload('90699bfa', component.options)
    }
    module.hot.accept("./UserSearch.vue?vue&type=template&id=90699bfa", function () {
      api.rerender('90699bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserSearch.vue"
export default component.exports